module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Building Survey Request")]), _vm._v(" "), (_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "header": "Request"
    }
  }, [_c('form', {
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "survey"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Survey Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyDto.surveyName),
      expression: "surveyDto.surveyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.surveyDto.surveyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyDto, "surveyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Estimated Field Dates")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyDto.fieldDatesEstimate),
      expression: "surveyDto.fieldDatesEstimate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.surveyDto.fieldDatesEstimate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyDto, "fieldDatesEstimate", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Actual Field Dates")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyDto.fieldDatesFinal),
      expression: "surveyDto.fieldDatesFinal"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.surveyDto.buildingSurveyId
    },
    domProps: {
      "value": (_vm.surveyDto.fieldDatesFinal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyDto, "fieldDatesFinal", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Survey Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyDto.surveyDescription),
      expression: "surveyDto.surveyDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.surveyDto.surveyDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyDto, "surveyDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveSurvey
    }
  }, [_vm._v("Save")])])])], 1)]), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Workflow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": _vm.buildingSurveyWorkflowId,
      "parentId": _vm.buildingSurveyId
    },
    on: {
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1), _vm._v(" "), (_vm.checkShpoRole) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('quickLetter', {
    attrs: {
      "projectId": _vm.project ? _vm.project.projectId : null,
      "buildingSurveyId": _vm.buildingSurveyId,
      "mediaTypeId": _vm.mediaTypeIdBsLetter,
      "parentId": _vm.buildingSurveyId
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('mediaLetter', {
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdBsLetter,
      "parentId": _vm.buildingSurveyId
    }
  })], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-986cd75e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BuildingSurvey.vue
// module id = 976
// module chunks = 1